import React from "react";
import { useQuery } from "@apollo/client";
import { FeatureSection } from "../../graphql/schema";
import { Grid } from "../common/grid/Grid";
import { GridItem } from "../common/grid/GridItem";
import { PageSection } from "../common/pageSection/PageSection";
import {
  makeStyles,
  mergeClasses,
  tokens,
  Text,
} from "@fluentui/react-components";
import { GET_FEATURES } from "../../graphql/queries";
import { useCmsLocale } from "../../i18n/cmsLocale";
import {
  BookRegular,
  ShieldErrorRegular,
  CalculatorRegular,
} from "@fluentui/react-icons";

const useStyles = makeStyles({
  content: {
    marginTop: tokens.spacingVerticalXXXL,
    marginBottom: tokens.spacingVerticalXXXL,
  },
  serviceItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: tokens.colorBrandBackground,
  },
  serviceText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "300px",
    rowGap: tokens.spacingVerticalXS,
  },
  icon: {
    height: "125px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: "100%",
      height: "100%",
    },
  },
  complianceIcon: {
    width: "99px",
  },
  riskAssessmentIcon: {
    width: "113px",
  },
  riskEconomyIcon: {
    width: "100px",
  },
});
export const Services = () => {
  const classes = useStyles();
  const locale = useCmsLocale();
  const { data, error, loading } = useQuery(GET_FEATURES, { variables: { locale } });
  if (loading || error || !data.featureSection) return <></>;
  const featureSection: FeatureSection = data.featureSection;
  type ServiceIconType =
    | "ComplianceOfDemands"
    | "RiskAssessment"
    | "RiskEconomy";
  const getIcon = (icon: ServiceIconType) => {
    switch (icon) {
      case "ComplianceOfDemands":
        return (
          <BookRegular
            className={mergeClasses(classes.icon, classes.complianceIcon)}
          />
        );
      case "RiskAssessment":
        return (
          <ShieldErrorRegular
            className={mergeClasses(classes.icon, classes.riskAssessmentIcon)}
          />
        );
      case "RiskEconomy":
        return (
          <CalculatorRegular
            className={mergeClasses(classes.icon, classes.riskEconomyIcon)}
          />
        );
    }
  };

  return (
    <div>
      <PageSection>
        <Grid className={classes.content}>
          {featureSection.features ? (
            featureSection.features?.map((x, i) => (
              <GridItem
                key={i}
                size="4/12"
              >
                <div className={classes.serviceItem}>
                  {getIcon(x?.icon ?? "ComplianceOfDemands")}
                  <div className={classes.serviceText}>
                    <Text size={500} align="center" weight="semibold">
                      {x?.title ?? ""}
                    </Text>
                    <Text size={300} align="center">
                      {x?.description ?? ""}
                    </Text>
                  </div>
                </div>
              </GridItem>
            ))
          ) : (
            <></>
          )}
        </Grid>
      </PageSection>
    </div>
  );
};
